import MainLayout from '../layouts/main';
import Time from './time';

function TimePage() {
  return (
    <MainLayout loginRequired={false} studentRequired={false} title={TIME_PAGE_TITLE}>
      <Time />
    </MainLayout>
  );
}

export const TIME_PAGE_TITLE = 'زمان';

export default TimePage;
